"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertObjectToFormData = void 0;
function convertObjectToFormData(object, Ctr) {
    if (checkIsFormData(object)) {
        return object;
    }
    var form = Ctr ? new Ctr() : new FormData();
    // eslint-disable-next-line guard-for-in
    for (var key in object) {
        form.append(key, object[key]);
    }
    return form;
}
exports.convertObjectToFormData = convertObjectToFormData;
function checkIsFormData(object) {
    var _a;
    return ((_a = object.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'FormData';
}
//# sourceMappingURL=convertObjectToFormData.js.map